import { CopySimple } from '@phosphor-icons/react';

export default CopySimple;
